<sc-padding class="no-field-space" *ngIf="!clientStatusService.isMobile">
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
    <sc-flex>
        <button mat-stroked-button (click)="cancelAction()" [disabled]="!cancelAllowed">
            <i class="far fa-times"></i> {{'confirm' | translate:
            ['tmc-yard.widgets.sac-client.station-transport-details.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button class="button" (click)="handlePreviousProcessingStatus()"
            *ngIf="isBackwardStatusButtonVisible" [disabled]="!changeProcessingStatusAllowed">
            <sc-icon iconClass="fa-chevron-left"></sc-icon>
            {{backwardStatusButtonDictionaryKey | translate: [backwardStatusButtonDictionaryKey,
            translationService.language]}}
        </button>
        <ng-container *ngIf="isForwardStatusButtonVisible">
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button class="button" (click)="handleNextProcessingStatus()"
                [disabled]="!changeProcessingStatusNextAllowed || !changeProcessingStatusAllowed">
                {{forwardStatusButtonDictionaryKey | translate: [forwardStatusButtonDictionaryKey,
                translationService.language]}}
                <sc-icon iconClass="fa-chevron-right"></sc-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="isConfirmButtonVisible">
            <sc-content-spacer></sc-content-spacer>
            <div>
                <sc-flex>
                    <div class="options"
                        *ngIf="station.stationUsage.routingOptions != null && station.stationUsage.routingOptions.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>{{'complete action' | translate:
                                ['tmc-yard.widgets.sac-client.station-transport-details.action.complete-action',
                                translationService.language]}}</mat-label>
                            <mat-select [(value)]="station.stationUsage.selectedOption"
                                [disabled]="station.stationUsage.routingOptions.length === 0">
                                <mat-option *ngFor="let option of station.stationUsage.routingOptions" [value]="option">
                                    <span class="transport-options" [ngClass]="getStyles(option)">
                                        <ng-container *ngIf="option.dictionaryKey">
                                            {{ option.dictionaryKey | translate: [ option.dictionaryKey,
                                            translationService.language] }}
                                        </ng-container>
                                        {{ option.label }}
                                    </span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <sc-content-spacer></sc-content-spacer>
                    <button mat-flat-button class="button" (click)="confirmOptions()"
                        [disabled]="isConfirmOptionsDisabled"
                        [matTooltip]="'confirm' | translate: ['tmc-yard.widgets.sac-client.station-transport-details.action.confirm', translationService.language]">
                        <sc-icon iconClass="fa-check"></sc-icon>
                    </button>
                </sc-flex>
            </div>
        </ng-container>
    </sc-flex>
</sc-padding>

<div class="no-field-space mobile" *ngIf="clientStatusService.isMobile">
    <sc-flex [vertical]="true" [stretchContent]="true">

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <ng-container *ngIf="isBackwardStatusButtonVisible">
            <button mat-stroked-button (click)="handlePreviousProcessingStatus()"
                [disabled]="!changeProcessingStatusAllowed">
                <sc-icon iconClass="fa-chevron-left"></sc-icon>
                {{backwardStatusButtonDictionaryKey | translate: [backwardStatusButtonDictionaryKey,
                translationService.language]}}
            </button>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>

        <ng-container *ngIf="isForwardStatusButtonVisible">
            <button mat-flat-button (click)="handleNextProcessingStatus()"
                [disabled]="!changeProcessingStatusNextAllowed || !changeProcessingStatusAllowed">
                {{forwardStatusButtonDictionaryKey | translate: [forwardStatusButtonDictionaryKey,
                translationService.language]}}
                <sc-icon iconClass="fa-chevron-right"></sc-icon>
            </button>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>

        <ng-container *ngIf="isConfirmButtonVisible">

            <mat-form-field appearance="fill"
                *ngIf="station.stationUsage.routingOptions != null && station.stationUsage.routingOptions.length > 0">
                <mat-label>{{'complete action' | translate:
                    ['tmc-yard.widgets.sac-client.station-transport-details.action.complete-action',
                    translationService.language]}}</mat-label>
                <mat-select [(value)]="station.stationUsage.selectedOption"
                    [disabled]="station.stationUsage.routingOptions.length === 0">
                    <mat-option *ngFor="let option of station.stationUsage.routingOptions" [value]="option">
                        <span class="transport-options" [ngClass]="getStyles(option)">
                            <ng-container *ngIf="option.dictionaryKey">
                                {{ option.dictionaryKey | translate: [ option.dictionaryKey,
                                translationService.language] }}
                            </ng-container>
                            {{ option.label }}
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <button mat-flat-button class="button" (click)="confirmOptions()" [disabled]="isConfirmOptionsDisabled"
                [matTooltip]="'confirm' | translate: ['tmc-yard.widgets.sac-client.station-transport-details.action.confirm', translationService.language]">
                <sc-icon iconClass="fa-check"></sc-icon>
            </button>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

        </ng-container>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <sc-separator-line></sc-separator-line>

        <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

        <button mat-stroked-button (click)="cancelAction()" [disabled]="!cancelAllowed">
            <i class="far fa-times"></i> {{'confirm' | translate:
            ['tmc-yard.widgets.sac-client.station-transport-details.action.cancel', translationService.language]}}
        </button>

        <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

        <sc-separator-line></sc-separator-line>

        <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

        <div class="functions">

            <app-transport-details-dialog-action [transport]="transport"
                [disabled]="!station.stationUsage.transportDetailsAllowed" [asButton]="true"
                (onChange)="handleChange()">
            </app-transport-details-dialog-action>
            <app-link-transport-dialog-action [transportId]="transport?.id"
                [disabled]="!station.stationUsage.transportDetailsAllowed" 
                [asButton]="true" (onChange)="handleChange()">
            </app-link-transport-dialog-action>
            <app-attach-detach-transport-dialog-action [transport]="transport" [asButton]="true"
                (onChange)="handleChange()">
            </app-attach-detach-transport-dialog-action>
            <app-resend-message-action [transport]="transport" [station]="station" [disabled]="!station.stationUsage.umbrueckenAllowed"
                [asButton]="true">
            </app-resend-message-action>

        </div>

    </sc-flex>
</div>